import { render, staticRenderFns } from "./AdminImportHuc2.vue?vue&type=template&id=2025e08e&"
import script from "./AdminImportHuc2.vue?vue&type=script&lang=js&"
export * from "./AdminImportHuc2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports